// extracted by mini-css-extract-plugin
module.exports = {"social-share-buttons":"_3K0--","socialShareButtons":"_3K0--","social-share-group":"_1MTiN","socialShareGroup":"_1MTiN","social-share-button":"DRG32","socialShareButton":"DRG32"};